{
  "name": "ils-put",
  "displayName": "ILS PuT",
  "description": "ILS Software Prüfung und Training",
  "version": "3.3.1",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-build project --deployPath /app/dist --listenPort 3000 --nodePort 7000",
    "start": "adornis-build project start --no-production --inspect-port 9222",
    "start:embed-test": "concurrently --prefix-colors auto --names 'build,run' 'esbuild --bundle --format=esm --platform=node --packages=external --loader:.png=file --outdir=modules/embed-test/dist --watch modules/embed-test/startup.ts' 'dotenvx run -f modules/embed-test/.env -f .env -- node --watch modules/embed-test/dist/startup.js'",
    "test": "adornis-build project test --no-production --inspect-port 9222"
  },
  "dependencies": {
    "@adornis/address": "^15.0.33",
    "@adornis/adornis-components": "^15.1.36",
    "@adornis/analytics": "^16.0.27",
    "@adornis/ass": "^10.1.13",
    "@adornis/base": "^12.1.2",
    "@adornis/baseql": "^14.2.3",
    "@adornis/calendar": "^14.1.4",
    "@adornis/charts": "^15.0.33",
    "@adornis/chemistry": "^14.3.0",
    "@adornis/collab": "^3.1.23",
    "@adornis/config": "^10.4.4",
    "@adornis/counter": "^14.0.18",
    "@adornis/data-view": "^21.3.10",
    "@adornis/datetime": "^18.0.41",
    "@adornis/dialog": "^14.3.7",
    "@adornis/dragdrop": "^14.0.29",
    "@adornis/entity-picker": "^5.0.49",
    "@adornis/field-management": "^5.1.30",
    "@adornis/file-utils": "^15.1.7",
    "@adornis/filter": "^5.4.5",
    "@adornis/fonts": "^14.0.29",
    "@adornis/formfield": "^14.0.29",
    "@adornis/forms": "^18.0.32",
    "@adornis/functional-lit": "^2.2.19",
    "@adornis/import-export": "^18.0.40",
    "@adornis/internationalization": "^19.0.40",
    "@adornis/mails": "^20.1.10",
    "@adornis/pagination": "^15.0.27",
    "@adornis/payments": "^19.0.0",
    "@adornis/popover": "^18.0.40",
    "@adornis/print": "^15.0.33",
    "@adornis/recorder": "^15.0.36",
    "@adornis/router": "^4.4.9",
    "@adornis/ssr": "^12.0.12",
    "@adornis/tasks": "^1.0.19",
    "@adornis/testing": "^15.0.18",
    "@adornis/tiptap": "^6.0.39",
    "@adornis/translation": "^6.0.40",
    "@adornis/translation-core": "^5.0.14",
    "@adornis/user-forms": "^16.0.50",
    "@adornis/users": "^16.1.7",
    "@adornis/validation": "^10.5.0",
    "@adornis/versioned-entity": "^6.0.39",
    "@adornis/web-rtc": "^18.0.40",
    "@adornis/writer": "^18.0.41",
    "@faker-js/faker": "^8.4.1",
    "@fullcalendar/core": "^6.1.15",
    "@lit-labs/preact-signals": "^1.0.3",
    "@openreplay/tracker": "^13.0.2",
    "@openreplay/tracker-assist": "^9.0.1",
    "chartjs-adapter-luxon": "^1.3.1",
    "cors": "^2.8.5",
    "deep-equal-in-any-order": "^2.0.6",
    "fast-csv": "^5.0.2",
    "graphql": "^16.10.0",
    "lit": "^3.2.1",
    "livekit-client": "^2.9.4",
    "livekit-server-sdk": "^2.10.1",
    "logrocket": "^9.0.2",
    "luxon": "^3.5.0",
    "needle": "^3.3.1",
    "node-2fa": "^2.0.3",
    "openai": "^4.85.4",
    "qrcode": "^1.5.4",
    "daisyui": "5.0.0-beta.2",
    "rxjs": "^7.8.2",
    "ts-ebml": "^3.0.1",
    "@adornis/llm": "^20.2.4",
    "yjs": "13.6.23"
  },
  "devDependencies": {
    "@adornis/esbuild": "^13.1.12",
    "@types/chai": "^5.0.1",
    "@types/cors": "^2.8.17",
    "@types/deep-equal-in-any-order": "^1.0.4",
    "@types/qrcode": "^1.5.5",
    "@typescript-eslint/eslint-plugin": "^8.25.0",
    "c8": "^10.1.3",
    "chai": "^5.2.0",
    "eslint": "^9.21.0",
    "eslint-config-love": "^118.0.0",
    "eslint-config-prettier": "^10.0.2",
    "globals": "^16.0.0",
    "junit-merge": "^2.0.0",
    "mocha": "^11.1.0",
    "mocha-junit-reporter": "^2.2.1",
    "typescript": "^5.7.3"
  },
  "files": [
    "dist"
  ],
  "license": "ISC",
  "@adornis/esbuild": {
    "server-path": "src/server",
    "client-path": "src/client",
    "print-path": "src/print-components",
    "standalone-path": "src/standalone-components",
    "output-path": "dist"
  },
  "packageManager": "pnpm@9.10.0+sha512.73a29afa36a0d092ece5271de5177ecbf8318d454ecd701343131b8ebc0c1a91c487da46ab77c8e596d6acf1461e3594ced4becedf8921b074fbd8653ed7051c",
  "pnpm": {
    "patchedDependencies": {
      "livekit-server-sdk": "patches/livekit-server-sdk.patch",
      "@adornis/baseql": "patches/@adornis__baseql.patch",
      "@adornis/collab": "patches/@adornis__collab.patch"
    }
  }
}
